// Store events
export function storeEvents(payload) {
  return { type: 'events:store', payload };
}

// Remove events
export function removeEvents(payload) {
  return { type: 'events:remove', payload };
}
